export interface TimeRange {
  id: string;
  start: string;
  end: string;
}

export function createTimeRange(start = '09:00', end = '17:00'): TimeRange {
  return { id: crypto.randomUUID(), start, end };
}
